import { onReady } from "../../utils/events/onReady";
import Swiper from '../../../node_modules/swiper/swiper-bundle.js';


export class Article {
    data = {};
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }

    init() {
        const swiper = new Swiper('.swiper.swiper-article-carousel', {
            
            direction: 'horizontal',
            loop: false,
            simulateTouch: false,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                formatFractionCurrent: function (number) {
                  return ('0' + number).slice(-2);
              },
              formatFractionTotal: function (number) {
                  return ('0' + number).slice(-2);
              }
              },
              effect: 'creative',
              creativeEffect: {
                prev: {
                  shadow: false,
                  translate: ["0%", 0, -1],
                  // opacity: 0
                },
                next: {
                  translate: ["60%", 0, 0],
                  opacity: 0,
                },
              },
              speed: 600,
          })
    }
}
